import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button, Center, Stack, Text } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  reloading: boolean;
}

export default class ChunkErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false, reloading: false };

  static getDerivedStateFromError(): State {
    return { hasError: true, reloading: false };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    const isChunkError =
      error.name === "ChunkLoadError" ||
      /loading chunk/i.test(error.message) ||
      /failed to fetch dynamically imported module/i.test(error.message);
    if (!isChunkError) {
      console.error("Unhandled render error", error, info);
    }
  }

  reload = () => {
    this.setState({ reloading: true });
    window.location.reload();
  };

  override render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Center minH="100dvh">
        <Stack align="center" gap={4}>
          <Text fontWeight="semibold">Something went wrong loading this page.</Text>
          <Button onClick={this.reload} loading={this.state.reloading} loadingText="Reloading…">
            Reload
          </Button>
        </Stack>
      </Center>
    );
  }
}
